import { render, staticRenderFns } from "./Customer-editor.vue?vue&type=template&id=4566bc97&scoped=true&"
import script from "./Customer-editor.vue?vue&type=script&lang=js&"
export * from "./Customer-editor.vue?vue&type=script&lang=js&"
import style0 from "./Customer-editor.vue?vue&type=style&index=0&id=4566bc97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4566bc97",
  null
  
)

export default component.exports